import { v4 as uuid } from "uuid";

import * as EntitySocialProcurement from "../entities/socialProcurement";
import { PlaceLatLng } from "./location";
import { SocialCommitmentTypeSpend } from "./commitment";
export type SocialProcurement = EntitySocialProcurement.SocialProcurement;

export enum SocialProcurementEntityType {
  SocialEnterprise = "social-procurement-entity-type_social-enterprise",
  DisabilityEnterprise = "social-procurement-entity-type_disability-enterprise",
  IndigenousEnterprise = "social-procurement-entity-type_indigenous-enterprise",
}

export const socialProcurementEntityTypeToString = (
  socialProcurementEntityType: SocialProcurementEntityType
): string => {
  switch (socialProcurementEntityType) {
    case SocialProcurementEntityType.SocialEnterprise:
      return "Social Enterprise";
    case SocialProcurementEntityType.DisabilityEnterprise:
      return "Disability Enterprise";
    case SocialProcurementEntityType.IndigenousEnterprise:
      return "Indigenous Enterprise";
  }
};

export interface SocialProcurementLineItem {
  id: string;
  reportId: string;
  transactionDate: Date;
  entityType: SocialProcurementEntityType;
  supplier: string;
  abn: string;
  supplierCountry: string;
  supplyPostCode: string;
  geoLocation: PlaceLatLng;
  invoiceReference: string;
  natureOfExpenditure: string;
  invoiceValue: number;
  copyOfInvoice: string;
  comments: string;
  socialFactors: string[];
  created: Date;
}

export const createDefaultSocialProcurement = (
  reportId: string
): SocialProcurementLineItem => {
  return {
    id: uuid(),
    reportId: reportId,
    transactionDate: new Date(),
    entityType: SocialProcurementEntityType.SocialEnterprise,
    supplier: "",
    abn: "",
    supplierCountry: "AU",
    supplyPostCode: "",
    geoLocation: { lat: 0, lng: 0 },
    invoiceReference: "",
    natureOfExpenditure: "",
    invoiceValue: 0,
    copyOfInvoice: "",
    comments: "",
    socialFactors: [],
    created: new Date(),
  };
};
